import {Pipe, PipeTransform} from '@angular/core';
import {ChallengeMetric} from 'src/app/core/model/project';
import {getTargetDisplayString} from '../utils/challenge-target-display.util';

@Pipe({
  name: 'cbTargetDisplay',
  standalone: true,
})
export class CbTargetDisplayPipe implements PipeTransform {
  transform(metric: ChallengeMetric): string {
    return getTargetDisplayString(metric);
  }
}
